import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

/**
 * ✅ เก็บสถานะ paging ของแต่ละตารางใน localStorage
 * เช่น จำนวนแถวต่อหน้า (pageSize) และหน้าปัจจุบัน (page)
 */
export const usePagingStore = create(
  persist(
    (set, get) => ({
      tables: {},

      /** คืนค่าการตั้งค่า paging ของตารางที่ระบุ */
      getPaging: (tableKey, defaultSize = 10) => {
        const t = get().tables?.[tableKey];
        return {
          page: t?.page ?? 1,
          pageSize: t?.pageSize ?? defaultSize,
        };
      },

      /** ตั้งค่าหน้าปัจจุบัน */
      setPage: (tableKey, page) =>
        set((s) => {
          const prev = s.tables?.[tableKey] ?? { page: 1, pageSize: 10 };
          return {
            tables: {
              ...s.tables,
              [tableKey]: {
                ...prev,
                page: Math.max(1, Number(page) || 1),
              },
            },
          };
        }),

      /** ตั้งค่าจำนวนแถวต่อหน้า (และรีเซ็ตกลับหน้า 1) */
      setPageSize: (tableKey, size) =>
        set((s) => {
          const prev = s.tables?.[tableKey] ?? { page: 1, pageSize: 10 };
          const pageSize = Math.max(1, Number(size) || 10);
          return {
            tables: {
              ...s.tables,
              [tableKey]: { ...prev, pageSize, page: 1 },
            },
          };
        }),

      /** ✅ เพิ่ม: reset ค่า paging ของตารางหนึ่ง */
      reset: (tableKey) =>
        set((s) => {
          const next = { ...s.tables };
          delete next[tableKey];
          return { tables: next };
        }),
    }),
    {
      name: "ui_paging_pref_v1",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

/**
 * ✅ Hook ใช้งานในแต่ละตาราง เช่น useTablePaging("businessType")
 * ให้ re-render อัตโนมัติเมื่อค่า page หรือ pageSize เปลี่ยน
 */
export function useTablePaging(tableKey, defaultSize = 10) {
  const page = usePagingStore(
    (s) => s.tables?.[tableKey]?.page ?? 1
  );
  const pageSize = usePagingStore(
    (s) => s.tables?.[tableKey]?.pageSize ?? defaultSize
  );
  const setPage = usePagingStore((s) => s.setPage);
  const setPageSize = usePagingStore((s) => s.setPageSize);
  const reset = usePagingStore((s) => s.reset);

  return { page, pageSize, setPage, setPageSize, reset };
}

/** ค่ามาตรฐานที่ใช้ใน dropdown */
export const PAGE_SIZE_OPTIONS = [10, 25, 50];